import { PointCloud } from "@custom-types/point-cloud-types";
import { GUID } from "@faro-lotv/foundation";
import { createSelector } from "@reduxjs/toolkit";
import { getPointClouds } from "@store/point-clouds/point-clouds-selector-utils";
import { RootState } from "@store/store-helper";

/**
 * @returns An array of all loaded PointCloud entities
 */
export const pointCloudsSelector: (state: RootState) => PointCloud[] =
  createSelector(
    (state: RootState) => state,
    (state: RootState) => {
      return getPointClouds(state);
    }
  );

/**
 * Gets a point cloud entity by providing the point cloud ID
 */
export function getPointCloudByIdSelector(
  id: GUID
): (state: RootState) => PointCloud | undefined {
  return createSelector(
    (state: RootState) => state,
    (state: RootState) => {
      if (!id) {
        return undefined;
      }

      const pointClouds = pointCloudsSelector(state);
      return pointClouds.find((pointCloud) => pointCloud.id === id);
    }
  );
}
